export const menuGlobal = [
  {
    codigo: '790',
    descricao: 'Autorizações',
    icone: 'pi pi-lock-open',
    itens: [
      {
        codigo: '790-1',
        descricao: 'Grupo de Usuários',
        icone: 'pi pi-users',
        url: '/grupos-usuario',
        acao: 4,
        uid: 1893484202
      }
    ]
  },
  {
    codigo: '792',
    descricao: 'Ajustes e Consultas de Frequência',
    icone: 'pi pi-chart-pie',
    url: '/gestao-periodo',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '793',
    descricao: 'Justificativa de Ocorrência',
    icone: 'pi pi-comments',
    url: '/justificativas',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '791',
    descricao: 'Histórico de delegação',
    icone: 'pi pi-save',
    url: '/historico-usuario-delegacao',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '790',
    descricao: 'Marcação de Ponto',
    icone: 'pi pi-user',
    url: 'AA/AAPortal/MarcacaoDePronto',
    acao: 4
  },
  {
    codigo: '789',
    descricao: 'Relatórios',
    icone: 'pi pi-file',
    itens: [
      {
        codigo: '789-6',
        descricao: 'Agendados',
        icone: 'pi pi-file',
        url: '/relatorios',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-1',
        descricao: 'Funcionários',
        icone: 'pi pi-file',
        url: '/relatorios-funcionarios',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-3',
        descricao: 'Histórico de equipagem dos trens',
        icone: 'pi pi-file',
        url: '/relatorios-historico-equipagem-trem',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-2',
        descricao: 'Jornada de Trabalho',
        icone: 'pi pi-file',
        url: '/relatorios-jornada-trabalho',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-4',
        descricao: 'Atividades Excedentes',
        icone: 'pi pi-file',
        url: '/relatorios-atividades-excedentes',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-5',
        descricao: ' Divergência Ponto-OS',
        icone: 'pi pi-file',
        url: '/relatorios-divergencia-ponto',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-7',
        descricao: 'Críticas de Intrajornda',
        icone: 'pi pi-file',
        url: '/relatorios-criticas-intrajornada',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-8',
        descricao: 'Atividades',
        icone: 'pi pi-file',
        url: '/relatorios-atividades',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-9',
        descricao: 'Adicionais',
        icone: 'pi pi-file',
        url: '/relatorios-adicionais',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-10',
        descricao: 'Divergências',
        icone: 'pi pi-file',
        url: '/relatorios-divergencias',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-11',
        descricao: 'Críticas de atividade',
        icone: 'pi pi-file',
        url: '/relatorios-criticas-atividade',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-12',
        descricao: 'Log de eventos',
        icone: 'pi pi-file',
        url: '/relatorios-log-eventos',
        acao: 4,
        uid: -1336615964
      },

      {
        codigo: '789-13',
        descricao: 'Horas Diurnas x Noturnas',
        icone: 'pi pi-file',
        url: '/relatorios-diurnas-noturnas',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-14',
        descricao: 'Cerca Eletrônica',
        icone: 'pi pi-file',
        url: '/relatorios-cerca-eletronica',
        acao: 4,
        uid: -1336615964
      },
      {
        codigo: '789-15',
        descricao: 'Reconhecimento Facial',
        icone: 'pi pi-file',
        url: '/relatorios-reconhecimento-facial',
        acao: 4,
        uid: -1336615964
      }
    ]
  },

  {
    codigo: '794',
    descricao: 'Atividades',
    icone: 'pi pi-sitemap',
    url: '/atividade-tipo',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '795',
    descricao: 'Perfil Frequência',
    icone: 'pi pi-user',
    url: '/funcionario',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '796',
    descricao: 'Configuraçõres Gerais',
    icone: 'pi pi-user',
    url: '/configuracoes',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '797',
    descricao: 'Período de Apuração',
    icone: 'pi pi-calendar-times',
    url: '/periodos',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '798',
    descricao: 'Bloqueio de Subperíodo',
    icone: 'pi pi-calendar-times',
    url: '/bloqueio-subperiodos',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '799',
    descricao: 'Desbloqueio de Subperíodo',
    icone: 'pi pi-calendar-times',
    url: '/listar-desbloqueio-periodo',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '801',
    descricao: 'Motivos',
    icone: 'pi pi-comments',
    url: '/motivos-indisponibilidade',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '802',
    descricao: 'Indisponibilidades',
    icone: 'pi pi-comments',
    url: '/indisponibilidades',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '803',
    descricao: 'Ordem de serviço',
    icone: 'pi pi-sort-alt',
    url: '/ordem-servico',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '804',
    descricao: 'Consolidação Folha',
    icone: 'pi pi-sort-alt',
    url: '/consolidacao-folha',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '805',
    descricao: 'Cerca Eletrônica',
    icone: 'pi pi-sort-alt',
    url: '/cerca-eletronica',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '807',
    descricao: 'Reconversão Manual',
    icone: 'pi pi-sync',
    url: '/reconversao-manual',
    acao: 4,
    uid: 1893484333
  },
  {
    codigo: '808',
    descricao: 'Alertas Registro Ponto',
    icone: 'pi pi-calendar-times',
    url: '/alerta',
    acao: 4,
    uid: 1893484333
  },
]
